import { useRef } from 'react';
// material
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
// hooks
// components
import MenuPopover from '../../../../minimals/MenuPopover';
import { MIconButton } from 'src/minimals/@material-extend';
import { useModal } from 'src/hooks/useModal';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { languageSelectors } from 'src/selectors';
import { setLanguage } from './../../../../redux/slices/language';

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const anchorRef = useRef(null);
  const [open, openModal, closeModal] = useModal();
  const { i18n } = useTranslation();
  const currentLang = useSelector(languageSelectors.getCurrentLanguage());
  const languages = useSelector(languageSelectors.getAllLanguages());
  const dispatch = useDispatch();

  const handleChangeLang = async (newLang) => {
    // TODO: ???? mejorar
    await i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang);
    dispatch(setLanguage({ code: newLang }));
    closeModal();
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={openModal}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.focusOpacity
              ),
          }),
        }}
      >
        <img src={currentLang.icon} alt={currentLang.label} />
      </MIconButton>
      <MenuPopover
        open={open}
        onClose={closeModal}
        anchorEl={anchorRef.current}
        sx={{ py: 1 }}
      >
        {languages.map((option) => (
          <MenuItem
            key={option.code}
            selected={option.code === currentLang.code}
            onClick={() => handleChangeLang(option.code)}
            sx={{ py: 1, px: 2.5 }}
          >
            <ListItemIcon>
              <Box component="img" alt={option.label} src={option.icon} />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
              {option.label}
            </ListItemText>
          </MenuItem>
        ))}
      </MenuPopover>
    </>
  );
}
